/** Ruta absoluta del resumen; la usa el listado de comentarios para navegar. */
export const SENTIMENT_SUMMARY_PATH = '/sentiment/summary';

/** Ruta absoluta del listado; la usan las tarjetas del resumen para navegar. */
export const SENTIMENT_COMMENTS_PATH = '/sentiment/comments';

export const SENTIMENT_CHAIN_SUMMARY_PATH = '/intercadena/sentimiento/resumen';
export const SENTIMENT_CHAIN_COMMENTS_PATH = '/intercadena/sentimiento/comentarios';
